import { PUBLIC_CARDANO_NETWORK } from '$env/static/public';
import type { SupabaseGrabbit } from '$lib/supabase';
import type { Database } from '$lib/types/supabase';

export default async function getCardanoNetworkParameters(
	supabase: SupabaseGrabbit
): Promise<CardanoNetworkParameters | undefined> {
	const { data, status, error } = await supabase
		.from('cardano_network')
		.select('*')
		.eq('name', PUBLIC_CARDANO_NETWORK.toLowerCase())
		.single();

	if (status === 200 && !error && data) {
		return data;
	}
}

export type CardanoNetworkParameters =
	Database['public']['Tables']['cardano_network']['Row'];
